export default function returnedMarginClass(marginLevel: number) {
  if (marginLevel >= 300) return "good-margin"
  if (marginLevel < 300 && marginLevel >= 150) return "regular-margin"
  return "bad-margin"
}
